import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRise = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		opacity: .2,
		cx: 9,
		cy: 9,
		r: 8.25,
		fill: "#34C759"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M12.75 9.75C11.9 9.05071 9 6.75 9 6.75C9 6.75 5.91219 9.20523 5.25 9.75",
		stroke: "#34C759",
		strokeWidth: 2,
		strokeLinecap: "round"
	})]
});
const ForwardRef = forwardRef(SvgRise);
export default ForwardRef;
